import { cn } from '@mint-lib/tw-utils';

import { CommandGroup as BasicCommandGroup } from '../../lib/command.jsx';
import { typographyVariants } from '../../lib/typography.jsx';

export default function CommandGroup({
  className,
  ...props
}: React.ComponentProps<typeof BasicCommandGroup>) {
  return (
    <BasicCommandGroup
      className={cn(
        typographyVariants({ variant: 'label01' }),
        '**:[[cmdk-group-heading]]:px-2 **:[[cmdk-group-heading]]:py-1',
        className,
      )}
      {...props}
    />
  );
}
